export const STORAGE_KEY_EMAIL = 'onegate_email';
export const STORAGE_KEY_LANGUAGE = 'onegate_language';
export const STORAGE_KEY_INVITATION_ID = 'onegate_invitation_id';
export const COOKIE_KEY_TOKEN = 'onegate_token';
